<template>
    <div class="outer-article-holiday-wrap" style="padding-top:0px;border:none;">
        <div class="article-blocks-masonry-wrap masonry load-masonry" data-breakpoint="600" v-for="(item,index) in showPosts" v-bind:key="index">
            <div class="masonry-link-wrap" :class="{ 'tall': indexPost % 2 === 0 }"  v-for="(post,indexPost) in item" v-bind:key="indexPost">
                <a :href="post.permalink" :title="post.title" class="article-masonry-img-wrap relative mb-16" v-if="post.holiday_images">
                    <video autoplay="autoplay" v-if="indexPost % 2 === 0 && post.holiday_videos.smaller_video.url" loop="loop" playsinline muted="muted" width="455" height="340" class="object-fit-cover" :poster="post.holiday_videos.smaller_video.poster">
                        <source :src="post.holiday_videos.smaller_video.url">
                    </video>
                    <img :src="post.holiday_images.smaller_image.url" v-else-if="indexPost % 2 === 0 && post.holiday_images.smaller_image.url" class="object-fit-cover" width="455" height="340" :alt="post.holiday_images.smaller_image.alt">
                    <video autoplay="autoplay" v-else-if="indexPost % 2 !== 0 && post.holiday_videos.bigger_video.url" loop="loop" playsinline muted="muted" width="455" height="340" class="object-fit-cover" :poster="post.holiday_videos.bigger_video.poster">
                        <source :src="post.holiday_videos.bigger_video.url">
                    </video>
                    <img v-else-if="indexPost % 2 !== 0 && post.holiday_images.bigger_image.url" :src="post.holiday_images.bigger_image.url" class="object-fit-cover" width="455" height="340" :alt="post.holiday_images.bigger_image.alt">
                </a>
                <a :href="post.permalink" :title="post.title" class="color-1 medium space-3 font-4 fs-text-7 mb-11 lh-2" v-html="post.title"></a>
                <a :href="post.author_link" :title="post.author" v-html="post.author" class="uppercase fs-text-3 space-1 color-1 font-4 medium"></a>
            </div>
        </div>
        
        <div class="loader-wrap" :class="{'active': isLoading == true}">
            <Loader/>
        </div>
        <div class="outer-load-more-wrap center mb-40" v-if="posts.length>showPosts.length">
            <div class="btn-wrap">
                <a href="#" @click.prevent="loadMore()" :title="strings[0]" class="btn-1 bg-1 color-2 uppercase font-4 medium fs-text-3 space-1 lh-4" v-html="strings[0]"></a>
            </div>
        </div>
    </div>
</template>

<script>
import Api from "../assets/js/helpers/axios";
import Loader from "./Loader";
import EA from 'helpers/init';
export default {
    name: 'HolidayLoad',
    data () {
        return {
            posts:[],
            page:0,
            isLoading: false,
            showPosts:[],
        };
    },
    components:{
        Loader,
    },
    props:{
        offset: {
            type: Number,
            default: 0
        },
        cat_id: {
            type: Number,
            default: 0
        },
        strings:{
            type: Array,
            default: []
        },
        lang:{
            type: String,
            default: '',
        },
    },
    created() {},
    mounted() {
        this.getData();
    },
    methods: {
        async getData () {
            this.isLoading = true;
            try{
                let resp = await Api.get(admin_url + 'holiday_news', {
                    params: {
                        // _wpnonce: wpApiSettings.nonce,
                        lang: this.lang,
                        offset: this.offset,
                        cat_id: this.cat_id,
                        // page: this.page,
                    }
                });
                if (resp.data){
                    this.posts = this.posts.concat(resp.data.posts);
                    this.maxPosts = resp.data.max_posts;
                }
                this.isLoading = false;
            } catch (e) {
                console.log(e)
                this.isLoading = false;
            }
        },
        loadMore(){
            this.showPosts.push(this.posts[this.page]);
            setTimeout(() => {
                EA.Methods.blockMasonry(document.getElementsByClassName('load-masonry')[this.page])
                this.page++;
            }, 1)
        }
    }
};
</script>
